import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import HipobuyVsKakobuy from "../pages/articles/hipobuy-vs-kakobuy/page";
import HipobuyVsCSSBuy from "../pages/articles/hipobuy-vs-cssbuy/page";
import HipobuyVsSuperbuy from "../pages/articles/hipobuy-vs-superbuy/page";
import HipobuyVsOopbuy from "../pages/articles/hipobuy-vs-oopbuy/page";
import CategoryDeepDive from "../pages/articles/category-deep-dive/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-kakobuy",
    element: <HipobuyVsKakobuy />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-cssbuy",
    element: <HipobuyVsCSSBuy />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-superbuy",
    element: <HipobuyVsSuperbuy />,
  },
  {
    path: "/hipobuy-spreadsheet-vs-oopbuy",
    element: <HipobuyVsOopbuy />,
  },
  {
    path: "/hipobuy-spreadsheet-category-deep-dive",
    element: <CategoryDeepDive />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;